export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    if (response.data && response.data.error && response.data.error.message === 'Exception of type \'Abp.Domain.Entities.EntityNotFoundException\' was thrown.') {
      messages.push({ message: 'validation.notAccess' });
    }
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('NO_MOVEMENT_STOCK_IN_BON_STOCK') === 0) {
      messages.push({
        message: 'validationBonStock.noMovementStock',
      });
    }
    if (message.indexOf('BONSTOCK_MUST_HAVE_UNIQUE_MOUVEMENT') === 0) {
      messages.push({
        message: 'validationBonStock.uniqueMovementStock',
      });
    }
    if (message.indexOf('MOUVEMENTSTOCK_AND_LIGNECOMMANDE_MUST_HAVE_SAME_PRODUIT') === 0) {
      messages.push({
        message: 'validationBonStock.MovementStockAndLigneCommandeDifferent',
      });
    }
    if (message.indexOf('MOUVEMENTSTOCK_AND_LIGNECOMMANDE_MUST_HAVE_SAME_QUANTITY') === 0) {
      messages.push({
        message: 'validationBonStock.MovementStockAndLigneCommandeDifferentQuantity',
      });
    }
    if (message.indexOf('MOUVEMENT_STOCK_BAD_TYPE') === 0) {
      messages.push({
        message: 'validationBonStock.MovementStockBadType',
      });
    }
    if (message.indexOf('MOUVEMENT_STOCK_MUST_HAVE_STOCKABLE_PRODUIT') === 0) {
      messages.push({
        message: 'validationBonStock.noStockableProduit',
      });
    }
    if (message.indexOf('BONSTOCK_MOUVEMENTMUSTBESAMESENS') === 0) {
      messages.push({
        message: 'validationBonStock.MouvementSameSens',
      });
    }
    if (message.indexOf('QUANTITE_NOT_CORRECT') === 0) {
      messages.push({
        message: 'validationBonStock.quantiteNotCorrect',
      });
    }
  });
}
